import React from 'react';
import './App.css';
import Home from './Pages/LandingPage.js';
import { GlobalProvider, useGlobalState } from './contexts/GlobalContext';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Form from './Components/Form/Form';
import Login from './Components/Login';
import Header from './Components/Header';
import Sidebar from './Components/Sidebar';
import Contacts from './Pages/Contacts';
import User from './Pages/User';
import Contact from './Components/Contacts/Contact.js';
import Tasks from './Pages/Tasks';
import Dashboard from './Pages/Dashboard';
import RealEstateContainer from './Pages/RealEstateContainer';
import PropertyDetail from './Components/PropertyDetail';
import PropertyEdit from './Components/PropertyEdit';
import MyProfile from './Pages/MyProfile.js';
import Profile from './Pages/Profile';
import NewsFeed from './Pages/NewsFeed.js';
import Messages from './Pages/Messages.js';
import Mailbox from './Pages/Mailbox.js';
import ClosedTasks from './Components/ClosedTasks.js';
import BulletinBoard from './Pages/BulletinBoard.js';
import SignUp from './Pages/SignUp.js';
import Terms from './Components/Form/Terms.js';
import EditProfile from './Components/EditProfile.js';
import AdminAccessPanel from './Pages/AdminAccessPanel.js';
import BrokerageAgents from './Pages/BrokerageAgents.js';
import SuperAdminPanel from './Pages/SuperAdminPanel.js';
import CSVProcessor from './Pages/csvProcessor.js';
import Account from './Pages/Account.js';
import PropertySearch from './Pages/PropertySearch.js';
import NotFound from './Pages/NotFound.js';
import BridgeApiTest from './Pages/BridgeTest.js';
import FeedbackReview from './Pages/FeedbackReview.js';
import TestDashboard from './Pages/TestDashboard.js';
import VerifyEmail from './Pages/VerifyEmail.js';
import HelpGuide from './Pages/HelpGuide.js';
import Pipeline from './Pages/Pipeline.js';
import { isRealtor } from './utils/userAccess';

function RealtorRoute({ user, children }) {
  return isRealtor(user) ? children : <Navigate to="/home" replace />;
}

function AppRoutes() {
  const { state } = useGlobalState();
  const user = state.user;
  const userId = state.user?.id;

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/bridgeTest" element={<BridgeApiTest />} />
      <Route path="/home" element={<Dashboard />} />
      <Route path="/contacts" element={<Contacts contactType="contact" />} />
      <Route path="/pipeline" element={<Pipeline />} />
      <Route path="/contact/:id" element={<Contact />} />
      <Route path="/prospect/:id" element={<User />} />
      <Route path="/tasks" element={<Tasks />} />
      <Route path="/form" element={<Form />} />
      <Route path="/login" element={<Login />} />
      <Route path="/myListings" element={<RealtorRoute user={user}><RealEstateContainer creatorId={userId} /></RealtorRoute>} />
      <Route path="/allListings" element={<RealtorRoute user={user}><RealEstateContainer /></RealtorRoute>} />
      <Route path="/property/:id" element={<PropertyDetail />} />
      <Route path="/edit/:id" element={<PropertyEdit />} />
      <Route path="/profile/:userId" element={<Profile />} />
      <Route path="/profile/:user.userid" element={<MyProfile />} />
      <Route path="/edit-profile/:userId" element={<EditProfile />} />
      <Route path="/feed" element={<NewsFeed />} />
      <Route path="/messages" element={<Messages />} />
      <Route path="/mailbox" element={<Mailbox />} />
      <Route path="/closedTasks" element={<ClosedTasks />} />
      <Route path="/bulletinBoard" element={<BulletinBoard />} />
      <Route path="/signUp" element={<SignUp />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/adminAccess" element={<AdminAccessPanel/>} />
      <Route path="/brokerPanel" element={<BrokerageAgents/>} />
      <Route path="/csvProcessor" element={<RealtorRoute user={user}><CSVProcessor /></RealtorRoute>} />
      <Route path="/account" element={<Account />} />
      <Route path="/help" element={<HelpGuide />} />
      <Route path="/property-search" element={<RealtorRoute user={user}><PropertySearch /></RealtorRoute>} />
      <Route path="/404" element={<NotFound />} />
      
       {user && user.role === 'Titan' && (
        <>
          <Route path="/superAdminPanel" element={<SuperAdminPanel />} />
          <Route path="/titan/feedback" element={<FeedbackReview />} />
          <Route path="/titan/tests" element={<TestDashboard />} />
        </>
      )}

      {/* Catch-all 404 route */}
      <Route path="*" element={<Navigate to="/404" replace />} />

    </Routes>
  );
}

function AppLayout() {
  const { state } = useGlobalState();
  const user = state.user;

  return (
    <Router>
      <div className="App">
        {user && <Header />}
        <div className="container-fluid">
          <div className="row">
            {user && <Sidebar />}
             <main
                className={
                  user
                    ? "col-md-9 ms-sm-auto col-lg-10 px-md-4"
                    : "col-12 p-0"
                }
              >
              <AppRoutes />
            </main>
          </div>
        </div>
      </div>
    </Router>
  );
}


function App() {
  return (
    <GlobalProvider>
      <AppLayout />
    </GlobalProvider>
  );
}

export default App;
